<template>
  <span class="rounded-full bg-background">
    <RouterLink
      :to="to"
      class="relative inline-flex items-center justify-center rounded-full px-3 py-1 font-medium text-primary hover:bg-primary/8 focus:z-10 focus:outline-none"
    >
      <IconHeroiconsSolidPlus
        v-if="type === 'create'"
        class="mr-2"
      />
      <IconHeroiconsPencilSquare v-else class="mr-2" />
      <slot> Create New </slot>
    </RouterLink>
  </span>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

withDefaults(
  defineProps<{
    to: RouteLocationRaw
    type?: "create" | "edit"
  }>(),
  {
    type: "create",
  }
)
</script>
